import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M13 2H11V22H13V2Z" xmlns="http://www.w3.org/2000/svg" />,
  "LineXl"
);
